var _style, _path, _path2, _path3, _polyline, _polyline2, _path4, _g, _path5, _path6, _g2, _path7, _g3, _g4, _path8, _circle, _path9, _path10, _path11, _g5, _path12, _polygon, _polygon2, _path13, _circle2, _path14, _defs, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRolodexEmptyMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 350.6",
    style: {
      enableBackground: "new 0 0 400 350.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#676767;stroke-width:2.6292;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#676767;stroke-width:3.0093;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;stroke:#676767;stroke-width:2.6558;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#818181;stroke-width:1.4581;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#676767;stroke-width:2.2298;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#010101;stroke-width:1.7655;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#818181;stroke-width:1.5074;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#818181;stroke-width:1.5009;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#818181;stroke-width:1.8226;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#676767;stroke-width:1.5047;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:#F9D7E3;}\n\t.st11{fill:#FFFFFF;stroke:#676767;stroke-width:3.0613;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{clip-path:url(#SVGID_2_);fill:#F9D7E3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.7,201.4c0,0-17.6,17.1-63.5-9.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.9,267.6c0,5.3,2.3,45.9,2.3,45.9s-15.8,6-21.1,0.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.7,258.6c0,5.3,0.8,60.9,0.8,60.9s-15.8,6-21.1,0.8"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "153,175.9 153,202.9 112.3,297.7 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "193.6,297.7 153,202.9 153,297.7 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M120.4,60.2c2.2,1.5,2.8,4.5,1.3,6.7s-4.5,2.8-6.7,1.3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 89.4,
    y1: 323.2,
    x2: 89.4,
    y2: 331.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 100,
    y1: 328,
    x2: 93.1,
    y2: 333.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 102.6,
    y1: 339.4,
    x2: 94.3,
    y2: 336.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 94.9,
    y1: 348.2,
    x2: 92,
    y2: 340.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 83.2,
    y1: 347.3,
    x2: 88,
    y2: 340.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 77,
    y1: 337.3,
    x2: 85.7,
    y2: 337
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 81.4,
    y1: 326.4,
    x2: 86.8,
    y2: 333.2
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M69.5,217.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M4.3,243.7c-0.3-3.5,2.2-6.9,4.6-6.1s3.6,5.5,2.2,8.5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 66.2,
    y1: 282.2,
    x2: 57.7,
    y2: 290.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 57.7,
    y1: 282.2,
    x2: 66.2,
    y2: 290.7
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M84.4,165.2c-4.3,0.9-6.9,6.4-4.8,10.2c2.1,3.8,8.1,4.7,11.2,1.5c3-3.1,2-9.2-1.9-11.1 c-1.7-0.1-3.5-0.1-5.2-0.2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 387.7,
    y1: 142.8,
    x2: 377.2,
    y2: 153.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 377.2,
    y1: 142.8,
    x2: 387.7,
    y2: 153.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 368.6,
    y1: 65.6,
    x2: 360.2,
    y2: 74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 360.2,
    y1: 65.6,
    x2: 368.6,
    y2: 74
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M345.8,125.7c-1.1-4.5,2.5-9.5,7.1-10c1.1-0.1,1.9,0.9,2.4,1.8c1.7,2.5,2.7,5.7,1.8,8.6 S348.3,127.3,345.8,125.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 396,
    cy: 223.3,
    r: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M125,31.5c6.1-1.6,11.4-6.1,13.9-12c2.5-5.8,2-12.8-1.1-18.3c2.3,4.4,4.7,8.9,5.4,13.8s-0.6,10.4-4.5,13.5 c-4.5,3.6-11,3-16.8,2.2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250.6,76.6c-2-4.3-4.7-8.3-8-11.8c2.8,2.1,6.4,3.1,9.9,2.7c-4.9,1.3-9.6,3.6-13.7,6.6 c3.7-2.8,6.8-6.5,8.8-10.7c0.1,4.7,0.2,9.4,0.3,14"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.5,140.3c0.4-6.3-0.3-12.7-2.1-18.8c1.1,3.2,2.8,6.1,5,8.6c-5.5-0.4-11.1,0.1-16.4,1.6 c6.9-2.3,13.3-6.1,18.6-11c-3.8,5.9-7.1,12.1-10,18.5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 209.6,
    y: 160.4,
    transform: "matrix(0.1304 -0.9915 0.9915 0.1304 16.5307 363.8226)",
    className: "st2",
    width: 12.1,
    height: 24.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "215.4,159 211.8,186.5 140.7,181.2 135.4,180.8 88.9,177.3 94.6,134.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.2,
    y: 142.5,
    transform: "matrix(0.1304 -0.9915 0.9915 0.1304 -82.3659 215.2678)",
    className: "st2",
    width: 60.6,
    height: 24.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 148.6,
    transform: "matrix(0.1304 -0.9915 0.9915 0.1304 -86.5128 217.416)",
    className: "st10",
    width: 49.4,
    height: 18.9
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M17.6-30.3"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "153,257.4 133.2,267.3 153,267.3 172.7,267.3 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "153,257.1 125.9,270.7 153,270.7 180.1,270.7 "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M307.2,267.1l23.8-8.7c5.4-3.1,6.2-4.8,7.2-7.2c4.8-10.8-52.8-84.8-52.8-84.8l-26.5,9.7 c0,0,3.7,93.8,14.3,98.9c2.3,1.1,4,1.9,10.1,0.8L307.2,267.1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 261.7,
    cy: 163.8,
    r: 27.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.4,212.7c0,0-17.6,17.1-63.5-9.9"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 263.2,
    cy: 163.1,
    r: 27.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M234,179.1l28.3-10.3C262.3,168.8,259.4,196.2,234,179.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolodexEmptyMessage);
export default __webpack_public_path__ + "static/media/rolodexEmptyMessage.661ddfbe72b593e61c91ef5ba7fb7537.svg";
export { ForwardRef as ReactComponent };